import { post } from './ajax';

// 实名信息结构 isAuthenticated是否实名 identityCardInfo实名信息脱敏姓名 viewVo页面按钮色值
export interface AuthenticationRes {
  isAuthenticated: number;
  identityCardInfo: {
    userName: string;
  };
  viewVo: {
    commonColor: string;
    rightPhotoColor: string;
    wrongPhotoColor: string;
    textColor?: string;
    mainColor?: string;
  };
}
//
export interface AuthenticationReq {
  bizId: number;
  customerId: string;
  nb_app: string;
  mwalletToken: string;
  payMemberId: string;
}

export interface GetFaqUrlReq {
  nb_app?: string;
  nb_platform?: string;
  pageCode: string;
  faqType: number;
}

export interface GetFaqUrlRes {
  link: string;
  name: string;
}

export interface BizInfoReq {
  bizId: string;
}
export interface BizInfoRes {
  name: string;
  bizId: string;
  idType: string;
  nfcModeId: string;
  ui: string;
  certify_session_id?: string;
}
export interface CreateNFCUrlReq {
  iph: string;
  modeId: string;
  validTime: number;
  payMemberId: string;
}
export interface CreateNFCUrlRes {
  requestId?: string;
  link?: string;
}
export interface SubmitInfoByNFCReq {
  requestId: string;
  payMemberId: string;
  bizId: number;
}
export interface SubmitInfoByNFCRes {
  status: string;
  error: SubmitInfoByNFCResError;
  data: SubmitInfoByNFCResData;
}

interface SubmitInfoByNFCResError {
  code: number;
  type: string;
  message: string;
  level: number;
}
interface SubmitInfoByNFCResData {
  requestId: string;
  failCode: number;
  failMessage: string;
  status: string;
}
class Api {
  // 获取实名信息
  getAuthentication(params: AuthenticationReq): Promise<AuthenticationRes> {
    return post('/conch/auth/getAuthentication', { ...params });
  }
  getFaqUrl(params?: GetFaqUrlReq): Promise<GetFaqUrlRes> {
    return post('/conch/auth/usercertify/getFaqUrl', {
      ...params
    });
  }
  queryBizInfo(params: BizInfoReq): Promise<BizInfoRes> {
    return post('/conch/auth/certificateupload/queryBizInfo', { ...params }, { needErrorHandler: false });
  }
  createNFCCertifyUrl(param: CreateNFCUrlReq): Promise<CreateNFCUrlRes> {
    return post('/conch/auth/standardcertify/createNFCCertifyUrl', {
      ...param
    }, { needErrorHandler: false });
  }
  submitCertificateInfoByNfc(
    param: SubmitInfoByNFCReq
  ): Promise<SubmitInfoByNFCRes> {
    return post('/conch/auth/certificateupload/submitCertificateInfoByNfc', {
      ...param
    }, {needErrorHandler: false, formatError: false});
  }
}

export const api = new Api();
